import { render } from "./NewDatabaseComponent.vue?vue&type=template&id=ca8599a2"
import script from "./NewDatabaseComponent.vue?vue&type=script&lang=js"
export * from "./NewDatabaseComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__